export default __webpack_public_path__ + "007350395974e20d6d4ffa5af65855d6.jpg";